'use strict';

import controller from './printTracking.controller';

const component = {
    bindings: {},
    controller
};

export default component;